"use client";

import { LegalDocumentsPage } from "@/components/sections/LegalDocumentsPage";
import { cookiesData } from "@/data/cookies";

export default function CookiesPage() {
  return (
    <LegalDocumentsPage
      bannerTitle="Gestion des cookies"
      eyebrow="Transparence cookies"
      intro="Cette page détaille le rôle des traceurs techniques utilisés sur le site, leur finalité et les options de paramétrage disponibles."
      articles={cookiesData}
    />
  );
}
